/**
 * Labstep
 *
 */

import { readEntitiesCount } from 'labstep-web/state/actions/entity';
import store from 'labstep-web/state/store';

export const getIncompleteExperimentsCount = (
  experimentWorkflowId: number,
): Promise<number> => {
  return new Promise((resolve) => {
    store.dispatch(
      readEntitiesCount(
        'experiment',
        {
          experiment_workflow_id: experimentWorkflowId,
          is_ended: false,
          is_root: false,
          get_count: 1,
        },
        {
          onSuccess: (response: any) => {
            resolve(response.response);
          },
        },
      ),
    );
  });
};
